import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {
  Button,
  Menu,
  MenuItem,
  Checkbox,
  IconButton
} from "@material-ui/core";
import PageviewIcon from "@material-ui/icons/Pageview";
import RebuildIcon from "@material-ui/icons/Autorenew";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";

export default class PopoverDownloadFilters extends React.Component {
  static propTypes = {
    showAdvancedSearch: PropTypes.bool.isRequired,
    showTimeZone: PropTypes.bool.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    advancedFiltersValid: PropTypes.arrayOf(PropTypes.object).isRequired,
    sampleFilter: PropTypes.string.isRequired,
    onApiURlClick: PropTypes.func.isRequired,
    lastRebuildDt: PropTypes.string,
    actions: PropTypes.shape({
      setFilterChanged: PropTypes.func.isRequired,
      fetchRecordCount: PropTypes.func.isRequired,
      toggleAdvancedSearch: PropTypes.func.isRequired,
      toggleTimeZone: PropTypes.func.isRequired,
      setFilterOpen: PropTypes.func.isRequired
    }).isRequired,
    filterOpen: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  handleTouchTap = event => {
    // This prevents ghost click.
    event.preventDefault();
    event.stopPropagation();

    this.setState({
      open: true,
      anchorEl: event.currentTarget
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false
    });
  };

  render() {
    const lastRebuildDt = moment(this.props.lastRebuildDt);
    const lastRebuildString = lastRebuildDt.isValid()
      ? `Last rebuild: ${lastRebuildDt.format("ll")}`
      : `Could not retrieve last rebuild date`;
    return (
      <span>
        <Button
          disableRipple
          disableFocusRipple
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();
          }}
          onMouseDown={event => event.stopPropagation()}
        >
          <RebuildIcon />
          <span>{lastRebuildString}</span>
        </Button>
        <Button
          onClick={this.handleTouchTap}
          onMouseDown={event => event.stopPropagation()}
        >
          <PageviewIcon
            onClick={this.handleTouchTap}
            onMouseDown={event => event.stopPropagation()}
          />
          <span>Options</span>
        </Button>
        <Menu
          anchorEl={this.state.anchorEl}
          autoWidth
          open={this.state.open}
          onClose={this.handleRequestClose}
        >
          <MenuItem
            key={1}
            disabled={!this.props.sampleFilter.length}
            onMouseDown={event => event.stopPropagation()}
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              if (this.props.advancedFiltersValid.length > 0)
                this.props.actions.setFilterChanged(true);
              this.props.actions.toggleAdvancedSearch();
              setTimeout(this.handleRequestClose, 500);

              if (
                this.props.showAdvancedSearch &&
                this.props.advancedFiltersValid.length
              ) {
                this.props.actions.fetchRecordCount();
              }
            }}
          >
            <Checkbox checked={this.props.showAdvancedSearch} /> Advanced Search
          </MenuItem>
          <hr />
          <MenuItem
            key={2}
            disabled={!this.props.sampleFilter.length}
            onMouseDown={event => event.stopPropagation()}
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              this.props.actions.toggleTimeZone();
              setTimeout(this.handleRequestClose, 500);
            }}
          >
            <Checkbox checked={this.props.showTimeZone} />
            Time Zone
          </MenuItem>
          <hr />
          <MenuItem
            key={3}
            disabled={!this.props.sampleFilter.length}
            onMouseDown={event => event.stopPropagation()}
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              this.props.onApiURlClick();
              this.handleRequestClose();
            }}
          >
            Display API Query
          </MenuItem>
        </Menu>
        <IconButton
          onClick={() => {
            this.props.actions.setFilterOpen(!this.props.filterOpen);
          }}
        >
          {this.props.filterOpen ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </IconButton>
      </span>
    );
  }
}

PopoverDownloadFilters.defaultProps = {
  lastRebuildDt: ""
};
